export default __webpack_public_path__ + "static/article-home-improvement-getting-the-right-loan-for-the-job-549335820d7a309c48a591bbc1b9467f.jpg";